export function useCompanyLogo(publicApiBase: string) {
  const { hostname } = useRequestURL()
  const subdomain = hostname.split(".")[0]

  return useFetch(`/partners/${subdomain}/logo`, {
    baseURL: publicApiBase,
    dedupe: "defer",
    enabled: () => Boolean(subdomain),
    transform: (response: { company_logo_url: string | null }) =>
      response.company_logo_url ?? undefined,
  })
}
